import { render } from "./Script.vue?vue&type=template&id=4d15b65c&scoped=true"
import script from "./Script.vue?vue&type=script&lang=js"
export * from "./Script.vue?vue&type=script&lang=js"

import "./Script.vue?vue&type=style&index=0&id=4d15b65c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d15b65c"]])

export default __exports__